import React, { useRef, useEffect } from 'react';
import Footer from '../components/Footer';
import '../App.css';

// 1. PROJECT DATA - Easy to update and expand
const projectData = [
  {
    id: 2,
    title: "Sustainable Organisation",
    date: "January 2026",
    scope: "Internal Policy Reform",
    description: "Establishment of comprehensive internal environmental governance frameworks, digitalization of vessel reporting systems, and continuous crew training programs in maritime decarbonization and ESG compliance.",
    images: ["/images/so.webp"]
  },
  {
    id: 3,
    title: "Sustainable Operations",
    date: "March 2026",
    scope: "Vessel Energy Efficiency",
    description: "Implementation of optimized voyage routing, dynamic hull cleaning protocols, and main engine load tuning to reduce bunker fuel consumption and curb greenhouse gas emissions across managed fleets.",
    images: ["/images/sop.webp"]
  },
  {
    id: 4,
    title: "Sustainable Solutions",
    date: "April 2026",
    scope: "Pollution Prevention",
    description: "Deployment of advanced ballast water treatment systems, bio-lubricants, eco-friendly antifouling technologies, and smart waste management protocols to preserve marine ecosystems and achieve zero pollution.",
    images: ["/images/sss.webp"]
  }
];

const Projects = ({ setPage }) => {
  const spotlightRef = useRef(null);

  useEffect(() => {
    const spotlight = spotlightRef.current;
    if (!spotlight) return;

    const handleMouseMove = (e) => {
      const rect = spotlight.parentElement.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      spotlight.style.setProperty('--mouse-x', `${x}px`);
      spotlight.style.setProperty('--mouse-y', `${y}px`);
      spotlight.classList.add('active');
    };

    const handleMouseLeave = () => {
      spotlight.classList.remove('active');
    };

    const parent = spotlight.parentElement;
    parent.addEventListener('mousemove', handleMouseMove);
    parent.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      parent.removeEventListener('mousemove', handleMouseMove);
      parent.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, []);

  return (
    <div>
      {/* Cover Image */}
      <div className="project-cover">
        <img src="/images/project.webp" alt="Projects Cover" className="project-cover-image" />
        <div className="project-cover-text">
          <h1>Marine Sustainability</h1>
          <p>
            Blue Waves Ship Management is dedicated to upholding the highest standards of
            marine environmental stewardship. We implement sustainable operational practices
            aimed at minimizing ecological impact.
          </p>
        </div>
      </div>

      {/* Project Section */}
      <section className="mcd-projects-section">
        <div className="mcd-container-project">
          <h2 className="mcd-section-title-project">Our Projects</h2>
          <div className="mcd-projects-grid">
            {projectData.map((project) => (
              <div key={project.id} className="mcd-project-card">
                <img src={project.images[0]} alt={project.title} />

                <h3>{project.title}</h3>
                <div className="project-date">{project.date}</div>
                <div className="project-scope">{project.scope}</div>
                <p className="project-description">{project.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Projects;